function isNewVisitor(cName) {
  var name = cName + "=";
  var cArray = document.cookie.split(';');
  for(var i=0; i < cArray.length; i++) {
    var c = cArray[i];
    c = c.trim();
    if (c.indexOf(name) == 0) {
    	return false;
    }
  }
  return true;
}

function showNewsletterPopup() {
  if (isNewVisitor("previousVisitor")) {
  	document.getElementById("n-p-b-frame").style.display = "block";
  	document.getElementById("n-p-bg").style.display = "block";
  }
}

function rememberVisitor() {
	var d = new Date();
	d.setTime(d.getTime() + (99999*24*60*60*1000));
  var expiration = "expires="+d.toUTCString();
  document.cookie = "previousVisitor=true; " + expiration;
}

function hidePopup() {
	document.getElementById("n-p-b-frame").style.display = "none";
  document.getElementById("n-p-bg").style.display = "none";
  rememberVisitor();
}